/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_FullscreenInputs */



/**
* | output |
* | --- |
* | "Toggle Fullscreen" |
*
* @param {Toggle_FullscreenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_fullscreen = /** @type {((inputs?: Toggle_FullscreenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_FullscreenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer en plein écran")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollbildmodus umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva schermo intero")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить полноэкранный режим")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar a pantalla completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换全屏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("全画面表示を切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपूर्ण स्क्रीन टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar tela cheia")
	return /** @type {LocalizedString} */ ("Toggle Fullscreen")
});